import styled from '@emotion/styled';

export let StyledImage = styled.img``;
